/**
 * @component BackLink
 * @description Einheitlicher "Zurueck zur Liste"-Link fuer Detailseiten.
 * Position: oben links ueber dem Titel.
 *
 * @prop {string}   to       - Ziel-Route (z.B. "/mitarbeiter")
 * @prop {string}   label    - Anzeigetext
 * @prop {function} [onClick] - Optional: Custom-Handler statt navigate(to)
 * @prop {string}   [className]
 */
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BackLink({ to, label, onClick, className = '' }) {
  const navigate = useNavigate();

  const handle = (e) => {
    e.preventDefault();
    if (onClick) onClick(e);
    else if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <button
      type="button"
      onClick={handle}
      className={`inline-flex items-center gap-1 text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors ${className}`}
    >
      <ChevronLeft className="w-4 h-4" strokeWidth={2} />
      <span>{label}</span>
    </button>
  );
}
